document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');

  if (!toggle || !menu) return;

  toggle.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    menu.classList.toggle('is-open', !open);
    document.body.classList.toggle('menu-open', !open);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-song-configurator]').forEach((configurator) => {
    const form = configurator.querySelector('[data-song-form]');
    const steps = [...configurator.querySelectorAll('[data-config-step]')];
    const totals = [...configurator.querySelectorAll('[data-config-total]')];
    const statuses = [...configurator.querySelectorAll('[data-config-status]')];
    const progressLabel = configurator.querySelector('[data-progress-label]');
    const progressBar = configurator.querySelector('[data-progress-bar]');
    const currency = configurator.dataset.currency || 'EUR';
    const basePrice = Number(configurator.dataset.basePrice || 0);
    let currentStep = 0;

    const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
      style: 'currency',
      currency
    }).format(cents / 100);

    const updateStatus = (message) => {
      statuses.forEach((status) => {
        status.textContent = message;
      });
    };

    const updateTotal = () => {
      const extras = [...form.querySelectorAll('[data-addon]:checked')]
        .reduce((sum, input) => sum + Number(input.dataset.price || 0), 0);
      const formattedTotal = money(basePrice + extras);
      totals.forEach((total) => {
        total.textContent = formattedTotal;
      });
    };

    const showStep = (index) => {
      currentStep = Math.max(0, Math.min(index, steps.length - 1));
      steps.forEach((step, stepIndex) => {
        step.hidden = stepIndex !== currentStep;
      });
      if (progressLabel) progressLabel.textContent = `Étape ${currentStep + 1} sur ${steps.length}`;
      if (progressBar) progressBar.style.width = `${((currentStep + 1) / steps.length) * 100}%`;
      document.body.classList.toggle('configurator-final-step', currentStep === steps.length - 1);
    };

    configurator.querySelectorAll('[data-next-step]').forEach((button) => {
      button.addEventListener('click', () => {
        const required = [...steps[currentStep].querySelectorAll('[required]')];
        if (required.some((field) => !field.reportValidity())) return;
        showStep(currentStep + 1);
      });
    });

    configurator.querySelectorAll('[data-previous-step]').forEach((button) => {
      button.addEventListener('click', () => showStep(currentStep - 1));
    });

    form.querySelectorAll('[data-addon]').forEach((input) => {
      input.addEventListener('change', updateTotal);
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const visibleRequiredFields = [...steps[currentStep].querySelectorAll('[required]')];
      const invalidField = visibleRequiredFields.find((field) => !field.checkValidity());
      if (invalidField) {
        invalidField.reportValidity();
        invalidField.focus();
        return;
      }

      const selectedAddons = [...form.querySelectorAll('[data-addon]:checked[data-variant]')];
      const submitButton = form.querySelector('button[type="submit"]');
      if (submitButton.disabled) return;
      submitButton.disabled = true;
      submitButton.textContent = 'Préparation du panier...';
      updateStatus('Préparation de votre commande...');

      const formData = new FormData(form);
      const properties = {};
      for (const [key, value] of formData.entries()) {
        if (key.startsWith('properties[') && value) {
          properties[key.slice(11, -1)] = value;
        }
      }

      const items = [{
        id: Number(form.dataset.mainVariant),
        quantity: 1,
        properties
      }];

      selectedAddons.forEach((input) => {
        items.push({ id: Number(input.dataset.variant), quantity: 1 });
      });

      try {
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 15000);

        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          cache: 'no-store',
          signal: controller.signal,
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items })
        });
        window.clearTimeout(timeout);
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.description || errorData.message || 'Un produit sélectionné est indisponible.');
        }
        updateStatus('Commande prête. Ouverture de votre panier...');
        window.location.assign(new URL(window.Shopify.routes.root + 'cart', window.location.origin).href);
      } catch (error) {
        const message = error.name === 'AbortError'
          ? 'La demande a pris trop de temps. Appuyez de nouveau.'
          : error.message;
        updateStatus(message);
        submitButton.disabled = false;
        submitButton.textContent = 'Réessayer';
      }
    });

    showStep(0);
    updateTotal();
  });
});
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-song-form]').forEach((form) => {
    const endpoint = (window.LMC_LEAD_ENDPOINT || '').trim();
    if (!endpoint) return;

    let timer;
    const leadId = window.crypto && window.crypto.randomUUID
      ? window.crypto.randomUUID()
      : `lead-${Date.now()}-${Math.random().toString(16).slice(2)}`;

    const getProperties = () => {
      const data = new FormData(form);
      const properties = {};

      for (const [key, value] of data.entries()) {
        if (key.startsWith('properties[') && value) {
          properties[key.slice(11, -1)] = value;
        }
      }

      return properties;
    };

    const getAddons = () => [...form.querySelectorAll('[data-addon]:checked')]
      .map((input) => {
        const label = form.querySelector(`label[for="${input.id}"] strong`);
        return label ? label.textContent.trim() : input.id;
      });

    const sendLead = (stage) => {
      const properties = getProperties();

      if (!properties['Email de livraison']) return;

      const payload = JSON.stringify({
        leadId,
        stage,
        properties,
        addons: getAddons(),
        page: window.location.href,
        userAgent: navigator.userAgent
      });

      if (navigator.sendBeacon) {
        navigator.sendBeacon(endpoint, new Blob([payload], { type: 'text/plain' }));
        return;
      }

      fetch(endpoint, {
        method: 'POST',
        mode: 'no-cors',
        keepalive: true,
        headers: { 'Content-Type': 'text/plain' },
        body: payload
      }).catch(() => {});
    };

    const scheduleLead = () => {
      clearTimeout(timer);
      timer = setTimeout(() => sendLead('formulaire commence'), 1200);
    };

    form.addEventListener('input', scheduleLead);
    form.addEventListener('change', scheduleLead);
    form.addEventListener('submit', () => sendLead('creation panier'));
  });
});
